import { Gauge } from "lucide-react";
import { cn } from "@/lib/utils";
import { useI18n } from "@/lib/i18n";

const OPTIONS = [
  { key: "aggressive",   color: "text-red-400 border-red-500/40 bg-red-500/10" },
  { key: "balanced",     color: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10" },
  { key: "conservative", color: "text-blue-400 border-blue-500/40 bg-blue-500/10" },
];

export default function SensitivitySelector({ value, onChange }) {
  const { t } = useI18n();
  return (
    <div className="flex items-center gap-2" data-testid="sensitivity-selector">
      <div className="flex items-center gap-1.5 text-[11px] text-zinc-500 whitespace-nowrap">
        <Gauge className="h-3.5 w-3.5" />
        {t("sensitivity")}:
      </div>
      <div className="flex items-center gap-1 rounded-sm bg-zinc-900/60 border border-zinc-800 p-0.5">
        {OPTIONS.map(opt => (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            data-testid={`sensitivity-${opt.key}`}
            className={cn(
              "px-2.5 py-1 rounded-sm text-[11px] font-bold transition-all whitespace-nowrap border",
              value === opt.key
                ? opt.color
                : "border-transparent text-zinc-500 hover:text-white"
            )}
          >
            {t(`sens_${opt.key}`)}
          </button>
        ))}
      </div>
    </div>
  );
}
